var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66429 7.18571L8.90714 6.42857L5.42143 9.91429L3.90714 8.4L3.15 9.15714L5.42143 11.4286L9.66429 7.18571ZM11.4286 1.42857H10.7143V0H9.28571V1.42857H3.57143V0H2.14286V1.42857H1.42857C0.635714 1.42857 0.00714285 2.07143 0.00714285 2.85714L0 12.8571C0 13.6429 0.635714 14.2857 1.42857 14.2857H11.4286C12.2143 14.2857 12.8571 13.6429 12.8571 12.8571V2.85714C12.8571 2.07143 12.2143 1.42857 11.4286 1.42857ZM11.4286 12.8571H1.42857V5H11.4286V12.8571Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppointment);
export default __webpack_public_path__ + "static/media/ic-appointment.eefe4e3d535f81b43fdbd21bc199e9dd.svg";
export { ForwardRef as ReactComponent };